<template>
  <div class="container approveDetail_reportItem">
    <el-row style="margin-bottom:20px">
      <el-button type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
      <!--关闭-->
      <el-button v-if="feedbackReport.canAudit" type="primary" v-acl="Feedback-reportsAudit" @click="audit('PASS')">{{$t("common.ApprovalPass")}}</el-button>
      <el-button v-if="feedbackReport.canAudit" type="primary" v-acl="Feedback-reportsAudit" @click="audit('REJECT')">{{$t("common.ApprovalReject")}}</el-button>
      <el-button v-if="feedbackReport.canSendCQS" type="primary" v-acl="Feedback-reportsAudit" @click="audit('UNJUDGEABLE')">{{$t("storeFeedback.report.sendCQS")}}</el-button>
    </el-row>
    <el-form :model="feedbackReport" ref="reportForm" label-position="right" inline label-width="220px" :rules="feedbackReportRules" class="">
      <el-card class="reportFormTop">
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.report.feedbackNo')">
              <el-input :value="feedbackHead.feedbackNo" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.report.reportNo')">
              <el-input :value="feedbackReport.reportNo" disabled clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.report.reportType')" prop="reportType">
              <!-- 调查报告类型 -->
              <IcSelect table="TT_FEEDBACK_REPORT" field="REPORT_TYPE" v-model="feedbackReport.reportType" clearable :disabled="!feedbackReport.canEdit"></IcSelect>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.supplierCostTime')">
              <el-input :value="(feedbackHead.supplierCostTime/60).toFixed(2)" disabled clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="20">
            <el-form-item :label="$t('storeFeedback.report.remark')" prop="reportRemark">
              <el-input type="textarea" autosize v-model="feedbackReport.reportRemark" clearable :disabled="!feedbackReport.canEdit" maxlength="200"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card>
        <!-- 基本信息 -->
        <div slot="header" class="clearfix">
          <span>{{$t("storeFeedback.report.basicInfo")}}</span>
        </div>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.receiveDate')">
              <!-- 接到反馈日期 -->
              <el-input :value="feedbackReport.receiveDate|dateFormatFilter('YYYY-MM-DD')" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.problemLevel')" class="widthReset">
              <!-- 投诉问题类别 -->
              <ic-select clearable table="TT_FEEDBACK_FIRST_CHECK" field="PROBLEM_LEVEL" v-model="feedbackReport.feedbackLevel" :disabled="!feedbackReport.canAudit"></ic-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.deadline')" v-if="!isStore">
              <!-- 初次最晚提交时间 -->
              <el-input :value="feedbackReport.reportDeadline|dateFormatFilter('YYYY-MM-DD HH:mm:ss')" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.haveRejected')" v-if="!isStore">
              <!-- 是否被CQS退回过 -->
              <el-input v-if='feedbackReport.haveRejectedByCqs' :value="feedbackReport.haveRejectedByCqs|ic('COMMON','YES_NO')" disabled clearable></el-input>
              <el-input v-else value="否" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.canContinue')" prop="canContinue">
              <!--能否继续使用-->
              <IcSelect table="COMMON" field="YES_NO" v-model="feedbackReport.canContinue" clearable :disabled="!feedbackReport.canAudit"></IcSelect>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.sampleHandleMethod')" prop="sampleHandleMethod">
              <!--留样处理-->
              <ic-select v-model="feedbackReport.sampleHandleMethod" table="TT_FEEDBACK_REPORT" field="SAMPLE_HANDLE_METHOD" clearable :disabled="!feedbackReport.canEdit"></ic-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.responsibleParty')" prop="responsibleParty" v-if="feedbackReport.canAudit">
              <!--责任方-->
              <ic-select v-model="feedbackReport.responsibleParty" :table-fields="responsiblePartyField" clearable></ic-select>
            </el-form-item>
            <el-form-item :label="$t('storeFeedback.report.responsibleParty')" prop="responsibleParty" v-else>
              <!--责任方-->
              <ic-select v-model="feedbackReport.responsibleParty" :table-fields="responsiblePartyField" clearable disabled></ic-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.needDebit')" prop="needDebit">
              <!--是否扣账-->
              <el-select v-model="feedbackReport.needDebit" @change='needDebitChange' clearable :disabled="!feedbackReport.canAudit">
                <el-option value="Y" label="是">是</el-option>
                <el-option value="N" label="否">否</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.debitNumber')" prop="debitNumber" :rules="isneedDebit ? feedbackReportRules.debitNumber : feedbackReportRules.debitNumber2">
              <!--扣账数量-->
              <el-input onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" v-model="feedbackReport.debitNumber" clearable :disabled="!feedbackReport.canAudit || !isneedDebit" maxLength='9'></el-input>
            </el-form-item>
          </el-col>
          <el-form-item :label="$t('storeFeedback.report.debitUnit')" prop="debitUnit">
            <!--扣账数量单位-->
            <el-input v-model="feedbackReport.debitUnitI18n" clearable :disabled="true"></el-input>
          </el-form-item>
        </el-row>
      </el-card>
      <el-card class="autoWidth">
        <!--详细调查报告-->
        <div slot="header" class="clearfix"><span>{{$t("storeFeedback.report.reportDetail")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')" prop="reportDetail">
              <!--描述-->
              <el-input type="textarea" autosize v-model="feedbackReport.reportDetail" clearable :disabled="!feedbackReport.canEdit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.DocAttachment')" prop="reportDetailDoc">
              <el-table :data="feedbackReport.reportDetailDoc" border highlight-current-row class="tableFile">
                <el-table-column sortable prop="documentName" :label="$t('common.file')">
                  <!--文件-->
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="tmDocumentId" min-width="130px" v-if="value.canEdit">
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,feedbackReport.reportDetailDoc)">{{$t('common.del')}}</el-link>
                    <!--删除-->
                  </template>
                </el-table-column>
              </el-table>
              <el-upload disabled v-if="feedbackReport.canEdit" ref="reportDetailDoc" action="upload" :http-request="reportDetailDocUpload" multiple :on-remove="reportDetailDocRemove" show-file-list="false" name="file">
                <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
              </el-upload>

            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.PicAttachment')">
              <el-upload class="hideView" :on-preview="reportDetailImgPreview" disabled list-type="picture-card" action="upload" :file-list="reportDetailImg">
                <div slot="file" slot-scope="{file}">
                  <el-input v-model="file.docComments" clearable disabled></el-input>
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                  <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="reportDetailImgPreview(file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span v-if="file.tmDocumentId" class="el-upload-list__item-delete" @click="downloadFile(file)">
                      <i class="el-icon-download"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible" class="enlargePhoto">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="autoWidth">
        <!-- 改进措施 -->
        <div slot="header"><span>{{$t("storeFeedback.report.treatment")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')">
              <el-input type="textarea" autosize v-model="feedbackReport.treatment" clearable :disabled="!feedbackReport.canEdit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.attachment')">
              <el-table :data="feedbackReport.treatmentDoc" border highlight-current-row class="tableFile">
                <el-table-column sortable prop="documentName" :label="$t('common.file')">
                  <!--文件-->
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="tmDocumentId" min-width="130px" v-if="value.canEdit">
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,feedbackReport.treatmentDoc)">{{$t('common.del')}}</el-link>
                    <!--删除-->
                  </template>
                </el-table-column>
              </el-table>
              <el-upload v-if="feedbackReport.canEdit" ref="treatmentDoc" action="upload" :http-request="treatmentDocUpload" multiple :on-remove="treatmentDocRemove" show-file-list="false" name="file">
                <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="autoWidth">
        <!--调查分析简报（供应商）-->
        <div slot="header"><span>{{$t("storeFeedback.report.supplierAnalysis")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')" prop="supplierAnalysis">
              <el-input type="textarea" autosize v-model="feedbackReport.supplierAnalysis" clearable :disabled="!feedbackReport.canEdit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="autoWidth">
        <!-- 调查分析简报（反馈中心-->
        <div slot="header"><span>{{$t("storeFeedback.report.CQSAnalysis")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')" prop='cqsAnalysis'>
              <el-input type="textarea" row="3" autosize v-model="feedbackReport.cqsAnalysis" :disabled="!feedbackReport.canAudit" clearable maxlength="1000"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
    </el-form>
    <el-dialog :title="approveTitle" :visible.sync="approveDialog" width="46%" class="popclass" :before-close="cancelapproveDialog">
      <el-row v-if="isPASS">
        <p style="color:red">请确认是否需要对投诉分类及等级进行调整？如需调整，点击取消按钮；无需调整，请直接审批通过即可。</p>
      </el-row>
      <el-form :model="approveForm" :rules="approveRules" ref="approveForm">
        <el-form-item :label="$t('common.remarks')" v-if='isPASS'>
          <!-- 通过备注-->
          <el-input v-model="approveForm.auditRemark" clearable maxlength="300"></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.remarks')" prop="sendCqsRemark" v-if='isSendCqs && isFBC'>
          <!-- 发送cqs备注-->
          <el-input v-model="approveForm.sendCqsRemark" clearable maxlength="300"></el-input>
        </el-form-item>
        <el-form-item :label="$t('storeFeedback.report.pleaseFillInRejectReason')" prop="RejectReason" v-if='isREJECT'>
          <!-- 拒绝原因-->
          <el-input v-model="approveForm.RejectReason" clearable maxlength="300"></el-input>
        </el-form-item>
        <el-form-item :label="$t('storeFeedback.report.ModifyReason')" prop="ModifyReason" v-if="showModifyReason">
          <!-- 问题等级修改后，必须填写修改原因;-->
          <el-input v-model="approveForm.ModifyReason" clearable maxlength="300"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancelapproveDialog">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="approveConfirm('approveForm')">{{$t('common.confirm')}}</el-button>

      </div>
    </el-dialog>
  </div>
</template>
<script>
import reportApi from "@/api/storeFeedback/report";
import IcSelect from "@/components/common/icSelect";
import FileList from "@/components/common/fileList";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";
import StoreFeedbackAttachments from "@/components/page/storeFeedback/storeFeedbackAttachments";
import { fileService } from "@/api/common/file-utils";
import bus from '../bus';
export default {
  name: "report-detail_report-item",
  components: { StoreFeedbackAttachments, FileList, IcSelect },
  props: {
    value: Object,
    feedback: Object,
    disabled: String,
    oldFeedbackDebits: Object
  },
  data() {
    var reportDetailDocValidator = (rule, value, callback) => {
      if (this.feedbackReport.reportDetailDoc.length == 0)
        if (this.reportDetailDoc2.length == 0) {
          callback(new Error(this.$t("storeFeedback.report.uploadFile")));
        }
        else {
          callback();
        }
    };
    var questionValidator = (rule, value, callback) => {
      if (this.questionDoc2.length == 0)
        callback(new Error(this.$t("storeFeedback.report.uploadFile")));
      else {
        callback();
      }
    };
    var answerDocValidator = (rule, value, callback) => {
      if (this.answerDoc2.length == 0 && this.feedbackReport.answerDoc2.length == 0)
        callback(new Error(this.$t("storeFeedback.report.uploadFile")));
      else {
        callback();
      }
    };
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      feedbackLevel: '',//问题等级
      oldNeedDebit: '',//是否扣账
      oldDebitNumber: '',//扣账数量
      oldResponsibleParty: '',//扣账数量
      showModifyReason: false,
      approveForm: {
        auditRemark: '',
        RejectReason: '',
        sendCqsRemark: '',
        ModifyReason: '',
      },
      isPASS: false,
      isREJECT: false,
      isSendCqs: false,
      approveTitle: '',
      approveDialog: false,
      auditStatus: '',
      isStore: false,
      isFBC: false,
      isMCD: false,
      isSUP: false,
      reportDetailDoc: [],//详细调查报告
      reportDetailDoc2: [],
      reportDetailImg: [],//详细调查报告  图片
      reportDetailImg2: [],
      treatmentDoc: [],//改进措施
      treatmentDoc2: [],
      questionDoc: [],//门店疑问
      questionDoc2: [],
      answerDoc: [],//疑问回复
      answerDoc2: [],
      disableQuestion: false,
      showQuestion: true,
      feedbackHead: this.feedback.feedback,
      feedbackReport: this.value,
      feedbackFirstCheck: this.feedback.feedbackFirstCheck,
      isneedDebit: false,
      feedbackReportRules: {
        reportType: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: ["change", "blur"] },
        ],
        canContinue: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: ["change", "blur"] },
        ],
        sampleHandleMethod: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "change" },
        ],
        responsibleParty: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "change" },
        ],
        needDebit: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "change" },
        ],
        debitNumber: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        debitNumber2: [
          { required: false }
        ],
        /*                    debitUnit: [
                                { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "change"},
                            ],
                            debitUnit2: [
                                { required: false}
                            ],*/
        reportDetail: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        reportDetailDoc: [{ required: true, validator: reportDetailDocValidator, trigger: 'change' }],
        supplierAnalysis: [{ required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }],
        cqsAnalysis: [{ required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }],
        answer: [{ required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }],
        answerDoc: [{ required: true, validator: answerDocValidator, trigger: 'change' }],

      },
      approveRules: {
        RejectReason: [{ required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }],
        sendCqsRemark: [{ required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }],
        ModifyReason: [{ required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }],
      },
      boxText: this.$t("storeFeedback.report.box")
    }
  },
  created() {
    let roles = JSON.parse(localStorage.getItem("ms_roles"));
    let emplFlag = localStorage.getItem('ms_emplFlag');
    //门店      SF_STORE_BASIC
    //反馈中心  SF_FBC_BASIC
    //麦当劳   SF_MCD_BASIC
    //供应商  SF_SUP_BASIC
    for (let i = 0, len = roles.length; i < len; i++) {
      if (roles[i] == 'SF_STORE_BASIC') {//门店
        this.isStore = true;
      }
      if (roles[i] == 'SF_FBC_BASIC') {//反馈中心
        this.isFBC = true;
      }
      if (roles[i] == 'SF_MCD_BASIC') {//麦当劳
        this.isMCD = true;
      }
    }
    if (emplFlag == "SUP") {//供应商
      this.isSUP = true;
    }
  },
  mounted() {
    this.getData();
    bus.$on('setLevel', data => {
      console.log('data', data);
      this.$set(this.feedbackReport, 'feedbackLevel', data)
    })
  },
  computed: {
    dataChanged() {
      let { value, feedback } = { value: this.value, feedback: this.feedback };
      return { value, feedback };
    },
    responsiblePartyField() {
      if (commonFun.isNotEmpty(this.feedbackReport.supplierType)) {
        if (this.feedbackReport.supplierType == "DC" || this.feedbackReport.supplierType == "CARRIER") {
          return [{ table: 'FEEDBACK_REPORT', field: "RESPONSIBLE_PARTY_DC" }];
        } else if (this.feedbackReport.supplierType == 'PLANT' || this.feedbackReport.supplierType == 'SUPPLIER') {
          return [{ table: 'FEEDBACK_REPORT', field: "RESPONSIBLE_PARTY_SUP" }];
        }
      } else {
        return [{ table: 'FEEDBACK_REPORT', field: "RESPONSIBLE_PARTY_DC" }, { table: 'FEEDBACK_REPORT', field: "RESPONSIBLE_PARTY_SUP" }];
      }
    },
    haveQuestion() {
      return !!this.feedbackReport.question ? 'Y' : 'N';
    },
    questionStatus() {
      if (commonFun.isEmpty(this.feedbackReport.question)) {
        return "NO_QUESTION";
      } else {
        if (commonFun.isEmpty(this.feedbackReport.answer)) {
          return "PENDIND";
        } else {
          return "ANSWERED";
        }
      }
    },

  },
  methods: {
    getData() {
      let action = this.$route.query.action;
      this.feedbackHead = this.feedback.feedback;
      this.feedbackReport = this.value;
      this.feedbackFirstCheck = this.feedback.feedbackFirstCheck;
      if ('Y' == this.feedbackReport.needDebit) {
        this.isneedDebit = true;
      }
      //获取问题等级
      // debugger
      this.feedbackLevel = this.value.feedbackLevel
      this.oldNeedDebit = this.value.needDebit;
      this.oldDebitNumber = this.value.debitNumber;
      this.oldResponsibleParty = this.value.responsibleParty;
      let reportDetailImg = this.value.reportDetailImg
      if (reportDetailImg != null && reportDetailImg.length > 0) {
        var temp = reportDetailImg.map(function (item) {
          let obj = {
            name: item["documentName"],
            url: '/adminconsole/file/downloadByKey?key=' + item["documentKey"],
            docComments: item["docComments"],
            fullPath: item["fullPath"],
            tmDocumentId: item["tmDocumentId"],
            documentName: item["documentName"],
            downloadType: item["downloadType"]
          };
          return obj;
        });
        this.reportDetailImg = temp
        this.reportDetailImg2 = reportDetailImg
      }
    },
    audit(auditStatus) {
      let that = this;
      let feedbackReport = this.feedbackReport;
      that.auditStatus = auditStatus
      feedbackReport.auditStatus = auditStatus;
      if ((that.feedbackLevel != that.value.feedbackLevel) ||
        (that.oldNeedDebit != that.value.needDebit) ||
        (that.oldResponsibleParty != that.value.responsibleParty) ||
        (that.oldDebitNumber != that.value.debitNumber)) {//修改了问题等级、是否扣账、扣账数量任意一个
        that.showModifyReason = true
        /*                   if(that.isMCD){//如果是mcd 问题等级修改后，必须填写修改原因
                               that.showModifyReason = true
                           }else{
                               that.showModifyReason = false
                           }*/

      } else {
        that.showModifyReason = false
      }
      if (auditStatus == "PASS") {
        this.approveTitle = that.$t("storeFeedback.report.auditPass")
        if (!feedbackReport.cqsAnalysis) {//通过时，调查分析简报（反馈中心）必须填写
          that.$refs.reportForm.validateField('cqsAnalysis');
          return;
        }
        that.isPASS = true
        that.isREJECT = false
        that.isSendCqs = false
        that.approveDialog = true
      }
      if (auditStatus == "REJECT") {
        this.approveTitle = that.$t("storeFeedback.report.auditReject")
        that.isPASS = false
        that.isREJECT = true
        that.isSendCqs = false
        that.approveDialog = true
      }
      if (auditStatus == "UNJUDGEABLE") {
        this.approveTitle = that.$t("storeFeedback.report.pleaseReason")
        that.isPASS = false
        that.isREJECT = false
        that.isSendCqs = true
        that.approveDialog = true
      }
    },
    approveConfirm(formName) {
      let that = this;
      let feedbackReport = that.feedbackReport;
      let auditStatus = feedbackReport.auditStatus
      that.$refs[formName].validate(valid => {
        if (valid) {

          if (auditStatus == "PASS") {
            feedbackReport.auditRemark = that.approveForm.auditRemark;
          }
          if (auditStatus == "REJECT") {
            feedbackReport.auditRemark = that.approveForm.RejectReason;
          }
          if (auditStatus == "UNJUDGEABLE") {
            feedbackReport.auditRemark = that.approveForm.sendCqsRemark;
          }
          feedbackReport.cqsChangeReason = that.approveForm.ModifyReason
          feedbackReport.ccs = that.feedbackFirstCheck.cc;

          reportApi.save(feedbackReport).then(resp => {
            if (resp.code != 200) {
              Message.error(resp.msg);
            } else {
              that.$message({
                message: that.$t("common.success"),
                type: "success"
              });
              that.feedbackReport.canAudit = false;
              that.feedbackReport.canEdit = false;
              that.feedbackReport.canSendCQS = false;
              that.approveDialog = false;
              // that.$router.go(-1);
            }
          })
        } else {
          return false;
        }
      });
    },
    cancelapproveDialog() {
      this.$refs.approveForm.clearValidate();
      this.approveDialog = false
    },
    historyBack() {
      this.$router.go(-1);
    },
    //详细调查报告附件上传
    reportDetailDocUpload: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        _this.reportDetailDoc2.push(res.data[0])
        _this.$refs.reportForm.validateField('reportDetailDoc');
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //详细调查报告删除(没保存前)
    reportDetailDocRemove(file) {
      for (let j = 0; j < this.reportDetailDoc2.length; j++) {
        if (this.reportDetailDoc2[j].documentName == file.name) {
          this.reportDetailDoc2.splice(j, 1)
        }
      }
    },
    //改进措施附件上传
    treatmentDocUpload: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        _this.treatmentDoc2.push(res.data[0])
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //改进措施 删除(没保存前)
    treatmentDocRemove(file) {
      for (let j = 0; j < this.treatmentDoc2.length; j++) {
        if (this.treatmentDoc2[j].documentName == file.name) {
          this.treatmentDoc2.splice(j, 1)
        }
      }
    },
    //疑问沟通附件上传
    questionDocUpload: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        _this.questionDoc2.push(res.data[0])
        _this.$refs.questionForm.validateField('questionDoc');
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //疑问沟通 删除(没保存前)
    questionDocRemove(file) {
      for (let j = 0; j < this.questionDoc2.length; j++) {
        if (this.questionDoc2[j].documentName == file.name) {
          this.questionDoc2.splice(j, 1)
        }
      }
    },
    //疑问回复 附件上传
    answerDocUpload: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        _this.questionDoc2.push(res.data[0])
        _this.$refs.questionForm.validateField('questionDoc');
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then(res => { });
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      let that = this
      fileService.deleteFile(tmDocumentId).then((res) => {
        this.$message({
          type: "success",
          message: this.$t("common.delSuccess"),
        });
        //删除成功删除列表数据
        files.splice(index, 1);
        that.getData()
      })
    },
    needDebitChange(val) {
      if (val == "Y") {
        this.isneedDebit = true
        this.feedbackReport.debitUnit = 'NEW_BOX';
        this.feedbackReport.debitUnitI18n = this.boxText;
      } else {
        this.isneedDebit = false
        this.feedbackReport.debitNumber = 0;
        this.feedbackReport.debitUnit = '';
        this.feedbackReport.debitUnitI18n = '';
      }
    },
    reportDetailImgPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
  watch: {
    dataChanged(newVal) {
      this.getData();
    }
  }
}

</script>
<style scoped  lang="scss">
.approveDetail_reportItem {
  .tableFile {
    margin-bottom: 20px;
  }
}
</style>
<style  lang="scss">
.approveDetail_reportItem {
  .reportFormTop {
    .el-form-item {
      display: flex;
      .el-form-item__content {
        flex: 1;
      }
    }
  }
  .autoWidth {
    .el-form-item.el-form-item--small {
      width: 100%;
      .el-form-item__content {
        width: 80%;
      }
    }
  }
  .el-select {
    width: 100%;
  }
  // .feedbackReport .el-input__inner{
  //     width:220px;
  // }
  // .el-input-number--small{
  //     width: 100%;
  // }
  .el-input-number {
    width: 100%;
  }
  // .widthReset .el-form-item__content{width:220px;}
  .colorBtn .el-button {
    background: #f8ab01 !important;
    color: #fff !important;
    border-color: #f8ab01 !important;
  }
  .hideView {
    .el-upload--picture-card {
      display: none;
    }
    .el-upload-list {
      display: flex;
      flex-wrap: wrap;
    }
    .el-input__inner {
      width: 100%;
    }
    .el-upload-list__item {
      position: relative;
      overflow: visible;
      margin-bottom: 45px;
      .el-input {
        position: absolute;
        bottom: -33px;
      }
      > div {
        height: 100%;
      }
    }
    .el-upload {
      margin-bottom: 30px;
    }
  }
  .enlargePhoto {
    .el-dialog {
      width: 90%;
      margin-top: 10px;
    }
  }
  .el-card {
    border-radius: 0;
  }
}
</style>
